var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Card-table-link-indicator-outer"},[_c('span',{staticClass:"Card-table-link-indicator"},[_c('font-awesome-icon',{attrs:{"icon":"chevron-right","size":"xs"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }